export const ME = 'ME';
export const LOG_IN = 'LOG_IN';
export const UPDATE = 'UPDATE';
export const LOG_OUT = 'LOG_OUT';



// WEBPACK FOOTER //
// ./src/actions/user/actionTypes.js